import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { Typography } from '@cp/ds/src/components/typography';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';
import { Box } from '@cp/ds/src/components/box';
import { useDeclination } from '@cp/shared/declination';
import { TariffsProps } from './model';

const SPACING = 1.5;

export const Tariffs: React.FC<TariffsProps> = ({ data, sx }) => {
  const theme = useTheme();
  const declination = useDeclination();

  return (
    <Stack direction="row" sx={mergeSx({ flexWrap: 'wrap', m: -(SPACING / 2) }, sx)}>
      {data.map(({ childrenCount, price }) => (
        <Box
          key={childrenCount}
          sx={{
            p: SPACING / 2,
            width: '100%',
            [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
              width: '50%',
            },
          }}
        >
          <Stack
            direction="row"
            gap={2}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              px: 1.5,
              py: 0.75,
              border: `1px solid ${theme.palette['gray light']}`,
              borderRadius: '8px',
              backgroundColor: theme.palette.white,
              alignItems: 'center',
            }}
          >
            <Typography variant="body">
              {childrenCount} {declination(childrenCount, DeclinationMnemonic.Child)}
            </Typography>
            <Typography variant="body bold">{price} руб/час</Typography>
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};
